const { jsPDF } = require("jspdf");
// const {
//   pageOneBorders,
//   pageTwoBoarders,
//   windScreenBoarders,
// } = require("../../public/static/json/borders.json");
const {
  pageOneBorders,
  pageTwoBoarders,
  windScreenBoarders,
} = require("@myjourney-assets/json/borders.json");
import getBrandFromUrl from "src/utils/getBrandFromUrl";
import getCountryFromURL from "src/utils/getCountryFromUrl";
// import BrandLogo from "../../public/static/json/logo.json";
import BrandLogo from "@myjourney-assets/json/logo.json";

const TWO_COL_PADDING = 95;
const PAGE_ONE_VERTICAL_NORMAL_PADDING = 53;
const INCIDENT_HEIGHT = 90;
const TITLE_PADDING_TOP = 7;
const VEHICLE_DAMAGE_OPTION_BOX_WIDTH = 3;
const THREE_COL_PADDING = 138;
const TWO_COOL_PADDING = 78;
const ONE_COL_PADDING = 15;

const getPhoneNumber = () => {
  const country = getCountryFromURL();
  const brand = getBrandFromUrl();
  return country == "AU" && brand == "Thrifty"
    ? "13 61 39"
    : brand == "Dollar" && country == "AU"
    ? "1800 501 934"
    : country == "AU"
    ? "13 30 39"
    : "0800 654 321";
};

const setupHeader = (doc, virReportNumber) => {
  const brand = getBrandFromUrl().toLowerCase();
  console.log("brand", brand);
  if (brand === "ace") {
    doc.addImage(BrandLogo[brand], "PNG", 10, 10, 50, 13);
  } else {
    doc.addImage(BrandLogo[brand], "PNG", 10, 10, 40, 13);
  }
  // Add Title
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text("Vehicle Incident Report: " + virReportNumber, 118, 15);

  // Add Subtitle
  doc.setFont("helvetica", "italic");
  doc.setFontSize(9);
  doc.setTextColor(169, 169, 169);
  doc.text(
    `For more information on this vehicle incident report, contact ${getPhoneNumber()}.`,
    97,
    23
  );
  doc.setTextColor(0, 0, 0);
};

const setupBorders = (doc, data) => {
  //   doc.line(107, 125, 107, 215);
  data.forEach((border) => {
    doc.rect(border.x, border.y, border.width, border.height);
  });
};

const setupSections = ({
  firstPageStartX,
  firstPageStartY,
  virData,
  customerNumbers,
  damageType,
  reportType,
  type,
}) => {
  console.log(virData);
  const windScreenSection = [
    {
      title: "RENTAL",
      x: firstPageStartX,
      y: firstPageStartY,
      fields: [
        reportType === "unReported"
          ? "Report Type: Un-reported"
          : damageType === "Rental"
          ? `Rental Agreement: ${virData.Rental.RentalAgreement}`
          : `Nonrev Agreement: ${virData.Rental.NonrevNumber}`,
        // `Customer Number: ${virData.Rental.CustomerNumber}`,
        `Customer Name: ${virData.Rental?.CustomerName || ""}`,
        `Rental Location: ${virData.Rental?.RentalLocation || ""}`,
        `Rental Date: ${virData.Rental?.RentalDate || ""}`,
      ],
    },
    {
      title: "VEHICLE",
      x: firstPageStartX + TWO_COL_PADDING,
      y: firstPageStartY,
      fields: [
        `Registration:${virData.Vehicle?.Registration}`,
        `VIN:${virData.Vehicle?.Vin}`,
        `Make:${virData.Vehicle?.Make}`,
        `Type:${virData.Vehicle?.Model}`,
      ],
    },
    {
      title: "INCIDENT",
      x: firstPageStartX,
      y: firstPageStartY + PAGE_ONE_VERTICAL_NORMAL_PADDING,
      fields: [
        `Date:${virData.IncidentDetails.Date?.slice(0, 10)}`,
        `Time:${virData.IncidentDetails.Date?.split("T")[1]?.slice(0, 8)}`,
        // `Location:${virData.IncidentDetails.Address || ""}`,
        `Description:${virData.IncidentDetails?.Description || ""}`,
      ],
    },
    {
      title: "VEHICLE DAMAGE",
      x: firstPageStartX + TWO_COL_PADDING,
      y: firstPageStartY + PAGE_ONE_VERTICAL_NORMAL_PADDING,
      fields: [
        `Reported: ${
          type === "windscreen"
            ? "WindScreen / Tyre"
            : type === "interior"
            ? "Interior / MissingItems"
            : "Mechanical"
        }`,
        `Damage:`,
      ],
    },
    {
      title: "ADDITIONAL DETAILS",
      x: firstPageStartX,
      y: firstPageStartY + PAGE_ONE_VERTICAL_NORMAL_PADDING * 3,
      fields: [virData.AdditionalDetails || ""],
    },
  ];
  const pageOneSection = [
    {
      title: "RENTAL",
      x: firstPageStartX,
      y: firstPageStartY,
      fields: [
        reportType === "unReported"
          ? "Report Type: Un-reported"
          : damageType === "Rental"
          ? `Rental Agreement: ${virData.Rental.RentalAgreement}`
          : `Nonrev Agreement: ${virData.Rental.NonrevNumber}`,
        // `Customer Number: ${virData.Rental.CustomerNumber}`,
        `Customer Name: ${virData.Rental?.CustomerName || ""}`,
        `Rental Location: ${virData.Rental?.RentalLocation || ""}`,
        `Rental Date: ${virData.Rental?.RentalDate || ""}`,
      ],
    },
    {
      title: "VEHICLE",
      x: firstPageStartX + TWO_COL_PADDING,
      y: firstPageStartY,
      fields: [
        `Registration:${virData.Vehicle?.Registration}`,
        `VIN:${virData.Vehicle?.Vin}`,
        `Make:${virData.Vehicle?.Make}`,
        `Type:${virData.Vehicle?.Model}`,
      ],
    },
    {
      title: "VEHICLE CONDITION",
      x: firstPageStartX,
      y: firstPageStartY + PAGE_ONE_VERTICAL_NORMAL_PADDING,
      fields: [
        `Vehicle Drivable:${virData.VehicleConditionAndPoliceDetails?.VehicleDrivable}`,
        `Vehicle Towed:${virData.VehicleConditionAndPoliceDetails?.VehicleTowed || ""}`,
        `Tow Company:${virData.VehicleConditionAndPoliceDetails?.TowCompany || ""}`,
        // `Insurance / Claim No.: ${virData.VehicleConditionAndPoliceDetails?.Insurance?.InsuranceNumber}`,
        // `Insurance Provider: ${virData.VehicleConditionAndPoliceDetails?.Insurance?.InsuranceProvider}`,
      ],
    },
    {
      title: "POLICE",
      x: firstPageStartX + TWO_COOL_PADDING,
      y: firstPageStartY + PAGE_ONE_VERTICAL_NORMAL_PADDING,
      fields: [
        `Police Attended:${virData.VehicleConditionAndPoliceDetails?.PoliceAttended}`,
        `Police Report:${
          virData.VehicleConditionAndPoliceDetails?.Police?.PoliceReportNumber || ""
        }`,
        `Police Officer:${virData.VehicleConditionAndPoliceDetails?.Police?.PoliceName || ""}`,
        `Police Station:${virData.VehicleConditionAndPoliceDetails?.Police?.PoliceStation || ""}`,
      ],
    },
    {
      title: "INSURANCE",
      x: firstPageStartX + THREE_COL_PADDING,
      y: firstPageStartY + PAGE_ONE_VERTICAL_NORMAL_PADDING,
      fields: [
        `HasInsurance:${virData.VehicleConditionAndPoliceDetails?.HasInsurance}`,
        `Insurance / Claim No.:${
          virData.VehicleConditionAndPoliceDetails?.Insurance?.InsuranceNumber || ""
        }`,
        `Insurance Provider:${
          virData.VehicleConditionAndPoliceDetails?.Insurance?.InsuranceProvider || ""
        }`,
      ],
    },
    {
      title: "INCIDENT",
      x: firstPageStartX,
      y: firstPageStartY + PAGE_ONE_VERTICAL_NORMAL_PADDING * 2,
      fields: [
        `Date:${virData.IncidentDetails.Date?.slice(0, 10)}`,
        `Time:${virData.IncidentDetails.Date?.split("T")[1]?.slice(0, 8)}`,
        `Customer Driving: ${virData.IncidentDetails?.RenterDriver}`,
        `Customer Present: ${virData.CustomerPresent}`,
        `Location:${virData.IncidentDetails.Address}`,
        `Description:${virData.IncidentDetails?.Description || ""}`,
      ],
    },
    {
      title: "VEHICLE DAMAGE",
      x: firstPageStartX + TWO_COL_PADDING,
      y: firstPageStartY + PAGE_ONE_VERTICAL_NORMAL_PADDING * 2,
      fields: ["Reported: Panel Damage / Accident", `Damage:`],
    },
    {
      title: "ADDITIONAL DETAILS",
      x: firstPageStartX,
      y:
        firstPageStartY +
        PAGE_ONE_VERTICAL_NORMAL_PADDING * 2 +
        INCIDENT_HEIGHT +
        TITLE_PADDING_TOP,
      fields: [virData.AdditionalDetails || ""],
    },
  ];
  const pageTwoSection = [
    {
      title: "OTHER DRIVER",
      x: 15,
      y: 20,
      fields: [
        `Customer #: ${customerNumbers?.OtherDriverNumber || ""}`,
        `Name: ${virData.OtherDriverDetails?.FirstName || ""} ${
          virData.OtherDriverDetails?.LastName || ""
        }`,
        `Relationship: ${
          virData.OtherDriverDetails?.Relationship === "Other"
            ? virData.OtherDriverDetails?.OtherRelationship
            : virData.OtherDriverDetails?.Relationship
        }`,
      ],
    },
    {
      title: "WITNESS 1",
      x: 78,
      y: 20,
      fields: [
        `Customer #:${customerNumbers.Witness1Number || ""}`,
        `Name: ${virData.Witness1?.FirstName || ""} ${virData.Witness1?.LastName || ""}`,
        // `Mobile: ${virData.Witness1?.Mobile || ""}`,
      ],
    },
    {
      title: "WITNESS 2",
      x: 138,
      y: 20,
      fields: [
        `Customer #:${customerNumbers.Witness2Number || ""}`,
        `Name: ${virData.Witness2?.FirstName || ""} ${virData.Witness2?.LastName || ""}`,
        // `Mobile: ${virData.Witness2?.Mobile || ""}`,
      ],
    },
    {
      title: "THIRD PARTY 1",
      x: 15,
      y: 70,
      fields: [
        `Customer #:${customerNumbers.ThirdPartyCustomerNumber || ""}`,
        `Name: ${virData.ThirdPartyDetail?.FirstName || ""} ${
          virData.ThirdPartyDetail?.LastName || ""
        }`,
        `Registration: ${virData.ThirdPartyDetail?.VehicleRegistration || ""}`,
        `Make/Type: ${
          (virData.ThirdPartyDetail?.VehicleMake || "") +
            "/" +
            (virData.ThirdPartyDetail?.VehicleModel || "") || ""
        }`,
        `Insurance Company: ${virData.ThirdPartyDetail?.InsuranceCompanyName || ""}`,
        `Policy:${virData.ThirdPartyDetail?.Policy || ""}`,
      ],
    },
    {
      title: "THIRD PARTY 2",
      x: 78,
      y: 70,
      fields:
        customerNumbers.AdditionalThirdParties && customerNumbers.AdditionalThirdParties.length > 0
          ? [
              `Customer #:${customerNumbers.AdditionalThirdParties[0]?.CustomerNumber || ""}`,
              `Name: ${virData.AdditionalThirdPartyDetails[0]?.FirstName || ""} ${
                virData.AdditionalThirdPartyDetails[0]?.LastName || ""
              }`,
              `Registration: ${virData.AdditionalThirdPartyDetails[0]?.VehicleRegistration || ""}`,
              `Make/Type: ${
                (virData.AdditionalThirdPartyDetails[0]?.VehicleMake || "") +
                "/" +
                (virData.AdditionalThirdPartyDetails[0]?.VehicleModel || "")
              }`,
              `Insurance Company: ${
                virData.AdditionalThirdPartyDetails[0]?.InsuranceCompanyName || ""
              }`,
              `Policy:${virData.AdditionalThirdPartyDetails[0]?.Policy || ""}`,
            ]
          : [
              `Customer #:`,
              "Name:",
              "Registration:",
              "Make/Type:",
              "Insurance Company:",
              "Policy:",
            ],
    },
    {
      title: "THIRD PARTY 3",
      x: 138,
      y: 70,
      fields:
        customerNumbers.AdditionalThirdParties && customerNumbers.AdditionalThirdParties.length > 0
          ? [
              `Customer #:${customerNumbers.AdditionalThirdParties[1]?.CustomerNumber || ""}`,
              `Name: ${virData.AdditionalThirdPartyDetails[1]?.FirstName || ""} ${
                virData.AdditionalThirdPartyDetails[1]?.LastName || ""
              }`,
              `Registration: ${virData.AdditionalThirdPartyDetails[1]?.VehicleRegistration || ""}`,
              `Make/Type: ${
                (virData.AdditionalThirdPartyDetails[1]?.VehicleMake || "") +
                "/" +
                (virData.AdditionalThirdPartyDetails[1]?.VehicleModel || "")
              }`,
              `Insurance Company: ${
                virData.AdditionalThirdPartyDetails[1]?.InsuranceCompanyName || ""
              }`,
              `Policy:${virData.AdditionalThirdPartyDetails[1]?.Policy || ""}`,
            ]
          : [
              `Customer #:`,
              "Name:",
              "Registration:",
              "Make/Type:",
              "Insurance Company:",
              "Policy:",
            ],
    },
  ];
  return { pageOneSection, pageTwoSection, windScreenSection };
};

const setupVehicleDamage = (doc, startx, starty, virData, type) => {
  // const targetDamages =
  //   type === "windscreen"
  //     ? ["Tyre-Driver", "Tyre-Passenger", "Windscreen-Driver", "Windscreen-Passenger"]
  //     : ["Driver", "Passenger", "Bonnet (Front)", "Boot (Rear)", "Roof", "Undercarriage"];

  let targetDamages;
  switch (type) {
    case "windscreen":
      targetDamages = [
        "Tyre Driver (TD)",
        "Tyre Passenger (TY)",
        "Windscreen Driver (WR)",
        "Windscreen Passenger (WP)",
      ];
      break;
    case "panel":
      targetDamages = [
        "Driver (PD)",
        "Passenger (PP)",
        "Bonnet (PB)",
        "Boot (PT)",
        "Roof (PR)",
        "Undercarriage (PU)",
      ];
      break;
    case "interior":
      targetDamages = ["Interior (IT)", "Cleaning (CN)", "Missing Items (MI)"];
      break;
    case "mechanical":
      targetDamages = ["Incorrect Fuel (IF)", "Engine / Mechanical (EM)"];
      break;
  }

  for (let i = 0; i < targetDamages.length; i++) {
    doc.rect(
      startx,
      starty + i * 10,
      VEHICLE_DAMAGE_OPTION_BOX_WIDTH,
      VEHICLE_DAMAGE_OPTION_BOX_WIDTH
    );
    doc.text(targetDamages[i], startx + 5, starty + 2.5 + i * 10);
  }

  // set damage cross
  for (const damageCode of virData.DamageDetails.DamageCodes) {
    console.log(damageCode);
    const index = targetDamages.indexOf(damageCode.Name);
    doc.line(
      startx,
      starty + index * 10,
      startx + VEHICLE_DAMAGE_OPTION_BOX_WIDTH,
      starty + VEHICLE_DAMAGE_OPTION_BOX_WIDTH + index * 10
    );
    doc.line(
      startx,
      starty + VEHICLE_DAMAGE_OPTION_BOX_WIDTH + index * 10,
      startx + VEHICLE_DAMAGE_OPTION_BOX_WIDTH,
      starty + index * 10
    );
  }
};

const renderSection = (doc, section) => {
  section.forEach((section) => {
    // Title
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(section.title, section.x, section.y);

    // Underline
    const textWidth = doc.getTextWidth(section.title);
    doc.setDrawColor(0);
    doc.setLineWidth(0.3);
    doc.line(section.x, section.y + 2, section.x + textWidth, section.y + 2);

    // Fields
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    if (section.title === "ADDITIONAL DETAILS") {
      section.fields.forEach((field, index) => {
        doc.text(field, section.x, section.y + 10 + index * 7, {
          maxWidth: 180,
        });
      });
    } else if (section.title === "OTHER DRIVER") {
      section.fields.forEach((field, index) => {
        doc.text(field, section.x, section.y + 10 + index * 7, {
          maxWidth: 60,
        });
      });
    } else {
      section.fields.forEach((field, index) => {
        doc.text(field, section.x, section.y + 10 + index * 7, {
          maxWidth: 90,
        });
      });
    }
  });
};

const setFooter = (doc) => {
  doc.setFontSize(8);
  doc.text(
    `${getBrandFromUrl().toUpperCase()} AUSTRALIA PTY. LIMITED A.B.N. 31 004 407 087`,
    10,
    283
  ); // Todo
  doc.text("Reg. Office: Level 1, 105 York Street, South Melbourne, VIC 3205 Australia", 10, 288);
};

const setupSigniture = (doc, y, signatureURL) => {
  const today = new Date();
  const formattedDate = `${today.getFullYear()}-${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${today
    .getDate()
    .toString()
    .padStart(2, "0")} ${today
    .getHours()
    .toString()
    .padStart(2, "0")}:${today.getMinutes().toString().padStart(2, "0")}`;
  doc.setLineWidth(0.1);
  doc.line(10, y, y, y);
  doc.setFont("helvetica", "bold");
  doc.text("Customer Signature", 13, y + 4);
  doc.text(`Date: ${formattedDate}`, 190, y + 4, { align: "right" });
  if (signatureURL) {
    doc.addImage(signatureURL, "PNG", 60, y - 10, 20, 20);
  }

  doc.setFont("helvetica", "normal");
};

const setupPanel = (doc, { pageOneSection, pageTwoSection }, virData, signatureURL, type) => {
  // first page border
  setupBorders(doc, pageOneBorders);
  setupVehicleDamage(doc, 111, 165, virData, type);
  renderSection(doc, pageOneSection);
  // set footer
  setFooter(doc);

  // second page
  doc.addPage();
  setupBorders(doc, pageTwoBoarders);
  renderSection(doc, pageTwoSection);

  // signiture
  setupSigniture(doc, 200, signatureURL);
};

const setupWindScreen = (doc, { windScreenSection }, virData, signatureURL, type) => {
  setupBorders(doc, windScreenBoarders);
  setupVehicleDamage(doc, 111, 110, virData, type);
  renderSection(doc, windScreenSection);
  // signiture
  setupSigniture(doc, 250, signatureURL);
};

const generatePdf = (param) => {
  const doc = new jsPDF();

  const virData = param.virData.data;
  const type = param.type;
  const signatureURL = param.signatureURL;
  const virReportNumber = param.virReportNumber;
  const customerNumbers = param.customerNumbers;
  const damageType = param.damageType;
  const reportType = param.reportType;
  // setup the header
  setupHeader(doc, virReportNumber);
  const sections = setupSections({
    firstPageStartX: 15,
    firstPageStartY: 37,
    virData: virData,
    customerNumbers: customerNumbers,
    damageType: damageType,
    reportType: reportType,
    type: type,
  });
  if (type === "panel") {
    setupPanel(doc, sections, virData, signatureURL, type);
  } else if (type === "windscreen" || type === "interior" || type === "mechanical") {
    setupWindScreen(doc, sections, virData, signatureURL, type);
  } else {
    console.log("No such type form.");
    return;
  }
  setFooter(doc);
  // doc.save(`signature-${virReportNumber}.pdf`);
  const pdfBlob = doc.output("blob");
  const url = URL.createObjectURL(pdfBlob);
  window.open(url, "_blank");
  return doc.output("blob");
};
export default generatePdf;
